import { render } from "./VehicleVersionStep.vue?vue&type=template&id=721db882&scoped=true"
import script from "./VehicleVersionStep.vue?vue&type=script&lang=js"
export * from "./VehicleVersionStep.vue?vue&type=script&lang=js"

import "./VehicleVersionStep.vue?vue&type=style&index=0&id=721db882&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-721db882"]])

export default __exports__